// Floating WhatsApp Button component
import React from 'react';
import '../../styles/shared/WhatsAppButton.css';

function WhatsAppButton() {
    const phoneNumber = '254703785199';
    const message = encodeURIComponent('Hello Signifide Group, I would like to enquire about your services.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float-button"
            aria-label="Chat with us on WhatsApp"
        >
            <div className="whatsapp-icon">
                <svg
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="white"
                >
                    <path d="M16 2C8.268 2 2 8.268 2 16c0 2.508.654 4.86 1.8 6.918L2.272 29.728l6.91-1.528C11.04 29.346 13.464 30 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.8c-2.268 0-4.452-.602-6.396-1.746l-.458-.27-4.594 1.012 1.228-4.474-.288-.472C4.756 19.886 4.2 17.96 4.2 16c0-6.518 5.282-11.8 11.8-11.8s11.8 5.282 11.8 11.8-5.282 11.8-11.8 11.8zm6.482-8.878c-.354-.178-2.098-1.036-2.422-1.154-.324-.118-.56-.178-.796.178-.236.354-.916 1.154-1.122 1.39-.206.236-.412.266-.766.088-.354-.178-1.496-.552-2.85-1.758-1.054-.94-1.766-2.098-1.972-2.452-.206-.354-.022-.546.154-.722.16-.16.354-.412.532-.65.178-.236.236-.396.354-.632.118-.236.058-.442-.03-.618-.088-.178-.796-1.918-1.09-2.628-.286-.692-.576-.598-.796-.608-.206-.01-.442-.01-.678-.01-.236 0-.62.088-.944.442-.324.354-1.236 1.208-1.236 2.946s1.266 3.416 1.444 3.652c.178.236 2.492 3.806 6.038 5.332 2.376 1.026 2.86.822 3.384.77.524-.052 1.676-.686 1.91-1.348.234-.662.234-1.23.164-1.348-.07-.118-.266-.178-.62-.356z"/>
                </svg>
            </div>
            <span className="whatsapp-tooltip">Chat with us on WhatsApp</span>
        </a>
    );
}

export default WhatsAppButton;
